import React, { useState } from 'react';
import { Languages, Loader2 } from 'lucide-react';
import { reviewsAPI } from '../services/api';
import { useT } from '../services/i18n';

/** Visitor-side « Translate » for a review whose language differs from the UI language (AI, cached per review+lang server-side). */
const ReviewTranslation = ({ review, children }) => {
  const { t, lang } = useT();
  const [tr, setTr] = useState(null);
  const [showOriginal, setShowOriginal] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const sourceLang = (review.lang || 'fr').slice(0, 2);
  if (sourceLang === lang) return children(review.title, review.comment, null);
  const translate = async () => {
    setBusy(true); setError('');
    try { setTr(await reviewsAPI.translate(review.id, lang)); setShowOriginal(false); } catch (e) { setError(e.response?.data?.detail || t('reviews.translateError')); } finally { setBusy(false); }
  };
  const translated = tr && !showOriginal;
  const footer = (
    <div className="flex items-center gap-2 text-[11px] text-gray-500 mt-1 flex-wrap" data-testid={`review-translate-${review.id}`}>
      {!tr ? (
        <button type="button" onClick={translate} disabled={busy} className="inline-flex items-center gap-1 text-blue-600 hover:underline disabled:opacity-60" data-testid={`review-translate-btn-${review.id}`}>
          {busy ? <Loader2 size={11} className="animate-spin" /> : <Languages size={11} />} {t('reviews.translate')}
        </button>
      ) : (
        <>
          <span className="inline-flex items-center gap-1"><Languages size={11} /> {translated ? t('reviews.translatedByAi') : t('reviews.originalShown')}</span>
          <button type="button" onClick={() => setShowOriginal(v => !v)} className="text-blue-600 hover:underline" data-testid={`review-translate-toggle-${review.id}`}>{translated ? t('reviews.showOriginal') : t('reviews.showTranslation')}</button>
        </>
      )}
      {error && <span className="text-red-600" data-testid={`review-translate-error-${review.id}`}>{error}</span>}
    </div>
  );
  return children(translated ? (tr.title || review.title) : review.title, translated ? tr.comment : review.comment, footer);
};

export default ReviewTranslation;
